import { render } from "./Setup.vue?vue&type=template&id=1d5a1a61"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"
script.render = render

export default script